import { render, staticRenderFns } from "./AccountHolderDashboard.vue?vue&type=template&id=52fabc72&scoped=true&data-perm-id=AccountHolderDashboard"
import script from "./AccountHolderDashboard.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDashboard.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderDashboard.vue?vue&type=style&index=0&id=52fabc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fabc72",
  null
  
)

export default component.exports